import { hasConsent } from './cookieConsent';

const SESSION_KEY = 'smartmenu.session';
const PERSISTENT_KEY = 'smartmenu.session.persistent';

const removeStoredState = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch (error) {
    console.error('Failed to clear session storage', error);
  }
  try {
    localStorage.removeItem(PERSISTENT_KEY);
  } catch (error) {
    console.error('Failed to clear persistent storage', error);
  }
};

const encode = (payload) => {
  try {
    return window.btoa(encodeURIComponent(JSON.stringify(payload)));
  } catch (error) {
    console.error('Failed to encode session payload', error);
    return null;
  }
};

const decode = (value) => {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(decodeURIComponent(window.atob(value)));
  } catch (error) {
    console.error('Failed to decode session payload', error);
    removeStoredState();
    return null;
  }
};

export const loadAuthState = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const persistent = hasConsent() ? localStorage.getItem(PERSISTENT_KEY) : null;
    const session = sessionStorage.getItem(SESSION_KEY);
    const source = persistent || session;
    return decode(source);
  } catch (error) {
    console.error('Failed to load stored auth state', error);
    removeStoredState();
    return null;
  }
};

export const saveAuthState = (payload) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const encoded = encode(payload);
    if (!encoded) {
      return;
    }
    sessionStorage.setItem(SESSION_KEY, encoded);
    if (hasConsent()) {
      localStorage.setItem(PERSISTENT_KEY, encoded);
    } else {
      localStorage.removeItem(PERSISTENT_KEY);
    }
  } catch (error) {
    console.error('Failed to store auth session', error);
    removeStoredState();
  }
};

export const clearAuthState = () => {
  removeStoredState();
};

export const promotePersistentStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const session = sessionStorage.getItem(SESSION_KEY);
    if (session && hasConsent()) {
      localStorage.setItem(PERSISTENT_KEY, session);
    } else if (!hasConsent()) {
      localStorage.removeItem(PERSISTENT_KEY);
    }
  } catch (error) {
    console.error('Failed to promote auth session', error);
    removeStoredState();
  }
};

export const getAccessToken = () => {
  const state = loadAuthState();
  return state?.tokens?.accessToken || null;
};

export const getRefreshToken = () => {
  const state = loadAuthState();
  return state?.tokens?.refreshToken || null;
};
